import { render, staticRenderFns } from "./paymentOrderD.vue?vue&type=template&id=554dc776&scoped=true&"
import script from "./paymentOrderD.vue?vue&type=script&lang=js&"
export * from "./paymentOrderD.vue?vue&type=script&lang=js&"
import style0 from "./paymentOrderD.vue?vue&type=style&index=0&id=554dc776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554dc776",
  null
  
)

export default component.exports